export default {
    create_clip_request_title: "Create Clip",
    create_clip_range: "Range",
    create_clip_start_date: "Start Date",
    create_clip_end_date: "End Date",
    create_clip_duration: "Duration (Seconds)",
    create_clip_max: "The maximum # required is",
    create_clip_min: "The minimum # required is",
    create_clip_get_clip: "Get Clip",
    create_clip_error_range: "The configured dates are out of range",
    create_clip_no_data: "No Data",

    create_clip_success_message: "The clip has been successfully requested",
    create_clip_error_clip: "Error when requesting the clip",
    create_clip_already_exists: "This clip already exists",
}